import { render, staticRenderFns } from "./CardEstimation.vue?vue&type=template&id=3dd63cb4&scoped=true"
import script from "./CardEstimation.vue?vue&type=script&lang=js"
export * from "./CardEstimation.vue?vue&type=script&lang=js"
import style0 from "./CardEstimation.vue?vue&type=style&index=0&id=3dd63cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd63cb4",
  null
  
)

export default component.exports